import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Colors, NonIdealState } from '@blueprintjs/core';
import styled from '@emotion/styled';
import { useDropzone } from 'react-dropzone';
import tinycolor from 'tinycolor2';
const DropzoneRoot = styled.div `
  position: relative;
  height: 100%;
  width: 100%;
`;
const DropzoneDragActive = styled.div `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgb(255, 255, 255, 0.7);
  border: 5px dashed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  border-color: ${({ borderColor }) => borderColor ?? tinycolor(borderColor).setAlpha(0.7).toRgbString()};
`;
const DropzoneEmpty = styled.div `
  :hover .dropzone-button {
    background-color: ${tinycolor(Colors.BLUE3).setAlpha(0.15).toRgbString()};
  }
  width: 100%;
  height: 100%;
  padding: 1em;
  border: 5px dashed;
  cursor: pointer;

  border-color: ${({ borderColor }) => borderColor};
`;
export function DropZone(props) {
    return _jsx(DropZoneContent, { ...props });
}
export function DropZoneContainer(props) {
    return _jsx(DropZoneContent, { ...props });
}
function DropZoneContent(props) {
    const { borderColor = Colors.GRAY3, children = null, onClick, emptyIcon = 'import', emptyTitle = 'No data loaded', emptyDescription = 'You can load data by drag-and-dropping files here', emptyButtonText = 'Select files', emptyButtonIcon = 'plus', noClick, ...otherProps } = props;
    const hasChildren = children !== null;
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        noClick: noClick ?? hasChildren,
        ...otherProps,
    });
    return (_jsxs(DropzoneRoot, { ...getRootProps({ onClick }), children: [children, isDragActive ? (_jsx(DropzoneDragActive, { borderColor: borderColor, children: _jsx(NonIdealState, { icon: "cloud-upload", title: "Drop the files here" }) })) : !hasChildren ? (_jsx(DropzoneEmpty, { borderColor: borderColor, children: _jsx(NonIdealState, { icon: emptyIcon, title: emptyTitle, description: emptyDescription, action: _jsx(Button, { className: "dropzone-button", outlined: true, text: emptyButtonText, icon: emptyButtonIcon, intent: "primary" }) }) })) : null, _jsx("input", { ...getInputProps() })] }));
}
//# sourceMappingURL=DropZone.js.map